import { createState } from "@/global/store/zustand_store";

export type SeatSelectionMode =
  | "autoSelect"
  | "manualSelect"
  | "changeInitialSelection"
  | null;

export const useAutoSeatSelectionState = createState({
  mode: null as SeatSelectionMode,
});
